import { render } from "./UpdateRegisterService.vue?vue&type=template&id=15a74c2f&ts=true"
import script from "./UpdateRegisterService.vue?vue&type=script&lang=ts"
export * from "./UpdateRegisterService.vue?vue&type=script&lang=ts"

import "./UpdateRegisterService.vue?vue&type=style&index=0&id=15a74c2f&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo_YHCT/ZaloOA_CLS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__